import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { FaCircleXmark } from "react-icons/fa6";
import BeatLoader from "react-spinners/BeatLoader";
import { Button, Input } from "../CustomComponents";
import SelectFieldComponent from "../CustomComponents/SelectFieldComponent";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import Toast, { ErrorToast, SuccessToast } from "../../Hooks/useToast";
import {
  useAddCategoryMutation,
  useUpdateCategoryMutation,
} from "../../Data/services/trainingApi";
import UserAvatarWithNameAndTag from "../UserAvatar/UserAvatarWithNameAndTag";
import LineRow from "../CustomComponents/LineRow";
import { useUpdateRequestMutation } from "../../Data/services/profileRequestApi";

const ProfileUpdateRequestModal = ({
  handleUpdateModalClose,
  data,
  handleUpdate,
  refetch,
}) => {
  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({});

  const [rowId, setRowId] = useState("");
  const [userSlug, setUserSlug] = useState("");

  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedQuestionType, setSelectedQuestionType] = useState("");

  const statusType = [
    {
      id: 20,
      name: "Approved",
    },
    {
      id: 30,
      name: "Rejected",
    },
  ];

  const statusTypeList = statusType.map((item) => ({
    label: item.name,
    value: item.id,
  }));

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (data) {
      console.log(data);
      setRowId(data.id);
      // setUserSlug(data.id);
      // setValue("name", data.name);
    }
  }, [data, mounted]);

  const handleStatusChange = (value) => {
    // console.log(value);
    setSelectedStatus(value);
  };

  const [updateStatus, { isLoading: updating }] = useUpdateRequestMutation();

  const handleSendData = async (record) => {
    console.log(record);
    console.log(rowId);

    try {
      const response = await updateStatus({ data: record, id: rowId }).unwrap();

      console.log(response);

      if (response?.error?.status === 400) {
        console.log(response?.error?.data?.message);
        ErrorToast(response?.error?.data?.message, "error");
      }

      if (response?.error?.status === 500) {
        ErrorToast(response?.error?.data?.message, "error");
      }

      if (response.code === 200) {
        SuccessToast(response?.message);
        handleUpdateModalClose();
        refetch();
      }
    } catch (error) {
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      }
    }
  };

  if (!mounted) {
    return;
  }

  return (
    <div>
      <ModalContainer handleClose={handleUpdateModalClose}>
        <div className={cssStyles.modalContainer} style={{ maxWidth: "90%" }}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-semibold m-0 black-text">Profile Update Request</p>
            <span className="bg-white bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleUpdateModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div className="w-100">
            <Row className="w-100">
              <Col sm={12} md={6}>
                <UserAvatarWithNameAndTag
                  userName={`${data?.firstname ? data?.firstname : ""} ${
                    data?.lastname ? data?.lastname : ""
                  }`}
                  avatarImage={
                    data.image_url || "/images/user-placeholder.jpeg"
                  }
                />
                <LineRow heading={"Updated Email"} text={data.email || "-"} />
                <LineRow
                  heading={"Updated Phone"}
                  text={data.mobile_no || "-"}
                />
                <LineRow
                  heading={"Updated Address"}
                  text={data.address || "-"}
                />
                <LineRow
                  heading={"Updated Country"}
                  text={data.country || "-"}
                />
                <LineRow
                  heading={"Updated DOB"}
                  text={data.date_of_birth || "-"}
                />
                <LineRow heading={"Updated About"} text={data.about || "-"} />
                
                {data.specialties?.length > 0 && (
                  <>
                  <hr className="w-100"></hr>
                    <p className="fw-bold">Updated Specialties :</p>
                    {data.specialties.map((item, index) => {
                      return <p>{item}</p>;
                    })}{" "}
                  </>
                )}

                <hr className="w-100"></hr>

                <Form onSubmit={handleSubmit(handleSendData)} className="w-75">
                  {errors?.status?.message ? (
                    <p className="m-0 text-danger text-center">
                      {errors?.status?.message}
                    </p>
                  ) : (
                    ""
                  )}
                  <Controller
                    control={control}
                    name="status"
                    rules={{
                      required: "Status Type is required.",
                    }}
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <SelectFieldComponent
                        firstOption={
                          _.isEmpty(selectedQuestionType)
                            ? "Select Status Type"
                            : selectedQuestionType
                        }
                        optionsList={statusTypeList}
                        value={value}
                        // onSelectChange={handleStatusChange}
                        onSelectChange={onChange}
                      />
                    )}
                  />

                  <Button
                    text={updating ? <BeatLoader size={10} /> : "Save"}
                    classes={`mt-2 mb-2 ${updating ? "bg-white-subtle" : ""}`}
                    type="submit"
                    // onClick={handleSubmit}
                    disabled={updating}
                  />
                </Form>
              </Col>
              <Col sm={12} md={6}>
                <p className="fw-bold">Updated Education Detail :</p>
                <LineRow
                  heading={"Updated University Name"}
                  text={data.education.university_name || "-"}
                />
                <LineRow
                  heading={"Updated Degree Name"}
                  text={data.education.degree_name || "-"}
                />
                <LineRow
                  heading={"Updated From Date"}
                  text={data.education.from_date || "-"}
                />
                <LineRow
                  heading={"Updated To Date"}
                  text={data.education.to_date || "-"}
                />
                <LineRow
                  heading={"Updated Country"}
                  text={data.education.country || "-"}
                />
                <LineRow
                  heading={"Updated City"}
                  text={data.education.city || "-"}
                />
                <hr className="w-100"></hr>
                <p className="fw-bold"> Updated Practice Detail:</p>
                <LineRow
                  heading={"Updated Hospital Name"}
                  text={data.practice.hospital_name || "-"}
                />
                <LineRow
                  heading={"Updated Practice Name"}
                  text={data.practice.practice_name || "-"}
                />
                <LineRow
                  heading={"Updated From Date"}
                  text={data.practice.from_date || "-"}
                />
                <LineRow
                  heading={"Updated End Date"}
                  text={data.practice.end_date || "-"}
                />
                <LineRow
                  heading={"Updated Country"}
                  text={data.practice.country || "-"}
                />
                <LineRow
                  heading={"Updated City"}
                  text={data.practice.city || "-"}
                />
              </Col>
            </Row>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default ProfileUpdateRequestModal;
